/* eslint-disable max-len */

import messages from 'src/messages';
import { parseJSON } from 'src/core/api/request';

const DEFAULT_ERROR_CODE = '000';

const errCodeToMessageMap = {
  GENERAL: messages.defaultApiErrorMessage,
  '000': messages.defaultApiErrorMessage,
  INVALID_FILE_EXTENSION: messages.invalidFileExtension,
  MISSING_FILE_URL: messages.missingFileUrl,
  INVALID_CART_REQUEST: messages.invalidCartRequest,
  INVALID_CSV_FILE: messages.invalidCsvFile,
  INVALID_MODIFICATION_3: messages.invalidModification3,
  INVALID_MODIFICATION_5: messages.invalidModification5,
  INVALID_MODIFICATION_5_FOR_96_WELL_PLATE:
    messages.invalidModification5PlateWell96,
  INVALID_MODIFICATION_5_FOR_384_WELL_PLATE:
    messages.invalidModification5PlateWell384,
  INVALID_OLIGO_SEQUENCE_LENGTH: messages.invalidOligoSequenceLen,
  INVALID_OLIGO_SEQUENCE_BASES: messages.invalidOligoSequenceBases,
  INVALID_OLIGO_NAME_LENGTH: messages.invalidOligoNameLen,
  INVALID_OLIGO_NAME_CHARACTERS: messages.invalidOligoNameChars,
  SCALE_AND_MODIFICATION_NOT_COMPATIBLE: messages.senseModificationIncompatible,
  INVALID_MODIFICATION_CODE: messages.invalidModificationCode,
  INVALID_SETTING: messages.invalidOligoPlateSetting,
  INVALID_BASE_LIMIT_FOR_CARTRIDGE_PURIFICATION:
    messages.invalidBaseLimitCartridgePurification,
  INVALID_SCALE_FOR_CARTRIDGE_PURIFICATION:
    messages.invalidScaleForCartridgePurification,
  INVALID_HPLC_PURIFICATION_FOR_25NMOLE:
    messages.invalidHPLCPurificationFor25nmole,
  INVALID_PAGE_PURIFICATION_FOR_25NMOLE:
    messages.invalidPagePurificationFor25nmole,
  INVALID_BASE_LIMIT_FOR_SYNTHESIS_SCALE:
    messages.invalidBaseLimitForSynthesisScale,
  INVALID_BASE_LIMIT_FOR_DESALTED_PURIFICATION:
    messages.invalidBaseLimitDesaltedPurification,
  INVALID_3PRIME_5PRIME_MODIFICATIONS:
    messages.invalid3Prime5PrimeModifications,
  INVALID_3PRIME_MODIFICATION_SCALE: messages.invalid3PrimeModificationScale,
  INVALID_5PRIME_MODIFICATION_SCALE: messages.invalid5PrimeModificationScale,
  INVALID_5PRIME_MODIFICATION_PURIFICATION:
    messages.invalid5PrimeModificationPurification,
  INVALID_5PRIME_MODIFICATION_FOR_HPLC_OR_PAGE_PURIFICATION:
    messages.invalid5PrimeModificationHplcPurification,
  OLIGO_PLATE_WELL_NOT_FOUND: messages.oligoPlateWellNotFound,
  OLIGO_PLATE_NOT_FOUND: messages.oligoPlateNotFound,
  OLIGO_PLATES_NOT_FOUND: messages.oligoPlateNotFound,
  INVALID_WELL: messages.invalidWell,
  INVALID_WELL_VOLUME: messages.invalidWellVolume,
  INVALID_VOLUME_NORMALIZATION_QTY: messages.invalidVolumeNormalizationQty,
  INVALID_CONCENTRATION_NORMALIZATION_QTY:
    messages.invalidConcentrationNormalizationQty,
  ALIQUOTS_ARE_NOT_ALLOWED: messages.aliquotesNotAllowed,
  POOLED_PLATES_ARE_NOT_ALLOWED: messages.pooledPlatesNotAllowed,
  REMAINDERS_ARE_NOT_ALLOWED: messages.remaindersNotAllowed,
  ALIQUOTS_LESS_THAN_MIN_QTY: messages.aliquotsMinError,
  ALIQUOTS_LESS_THAN_MIN_VOLUME: messages.aliquotsLessThanMinVolume,
  ALIQUOTS_EXCEEDS_MAX_VOLUME: messages.aliquotsMaxVolumeError,
  INVALID_POOLED_PLATE_VOLUME: messages.invalidPooledPlateVolume,
  INVALID_25_NMOLE_OLIGO: messages.invalid25NmoleOligo,
  INVALID_PLATE_NAME: messages.invalidPlateName,
  PLATE_NAME_EXISTS: messages.plateNameExists,
  INVALID_DELIMITER: messages.invalidDelimiter,
  DNA_TUBE_INVALID_NO_OF_COLUMNS: messages.dnaTubeInvalidNoColumns,
  DNA_TUBE_MISSING_MANDATORY_FIELD: messages.dnaTubeMissingMandatoryField,
  DNA_INVALID_DNA_TUBE_FILE: messages.dnaTubeInvalidTubeFile,
  DNA_EMPTY_DNA_TUBE_FILE: messages.dnaTubeInvalidTubeFileEmpty,
  DNA_PLATE_INVALID_NO_OF_COLUMNS: messages.dnaPlateInvalidNoOfColumns,
  DNA_PLATE_MISSING_MANDATORY_FIELD: messages.dnaPlateMissingMandatoryFields,
  DNA_PLATE_EMPTY_FILE: messages.dnaPlateEmptyFile,
  DNA_PLATE_INVALID_COLUMN_NO: messages.dnaPlateInvalidColumnNo,
  DNA_PLATE_INVALID_ROW: messages.dnaPlateInvalidRow,
  DNA_PLATE_DUPLICATE_WELL: messages.dnaPlateDuplicateWell,
  DNA_PLATE_DUPLICATE_PLATE: messages.dnaPlateDuplicatePlate,
  DNA_PLATE_HEADER_EMPTY_FILE: messages.dnaPlateHeaderEmptyFile,
  DNA_INVALID_PLATE_HEADER_FILE: messages.dnaPlateInvalidPlateHeaderFile,
  INVALID_DNA_RELATED_DETAILS: messages.invalidCombinations,
  INVALID_TEMPLATE_FILE: messages.invalidTemplateFile,
  DNA_PLATE_INVALID_ROW_CHARACTERS: messages.invalidRowCharacters,
};

const getErrMsgByErrCode = (code, paramValues) => {
  const message = errCodeToMessageMap[code] || messages.defaultApiErrorMessage;

  return paramValues ?
    {
      ...message,
      values: paramValues,
    } :
    message;
};

export const getErrorMessagesFromResponse = async (apiResponse) => {
  let response = apiResponse;

  if (response.body) {
    response = await parseJSON(response);
  }

  const errMessages = response.errors || [];

  return errMessages.map((msg) => {
    const code = msg.code || DEFAULT_ERROR_CODE;

    return getErrMsgByErrCode(code, msg.paramValues);
  });
};
